type Variant = 'primary' | 'outline-warning' | 'outline-success' | 'outline-neutral' | 'outline-danger';
type Size = 'sm' | 'md';

interface Props {
  children: React.ReactNode;
  type?: 'button' | 'submit';
  variant?: Variant;
  size?: Size;
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  'aria-label'?: string;
}

const variantStyles: Record<Variant, string> = {
  primary:
    'rounded-xl bg-gradient-to-r from-brand-600 to-accent-500 text-white shadow-lg shadow-brand-200/60 hover:from-brand-500 hover:to-accent-400 focus:ring-2 focus:ring-brand-300',
  'outline-warning':
    'rounded-lg border border-amber-200 bg-amber-50 text-amber-700 hover:border-amber-300 hover:bg-amber-100',
  'outline-success':
    'rounded-lg border border-accent-200 bg-accent-50 text-accent-700 hover:border-accent-300 hover:bg-accent-100',
  'outline-neutral':
    'rounded-lg border border-slate-200 bg-white/80 text-slate-600 hover:border-brand-200 hover:text-brand-700',
  'outline-danger':
    'rounded-lg border border-red-200 bg-red-50 text-red-700 hover:border-red-300 hover:bg-red-100',
};

const sizeStyles: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-3 text-sm',
};

export default function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  onClick,
  'aria-label': ariaLabel,
}: Props) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      className={[
        'inline-flex items-center justify-center font-semibold transition focus:outline-none disabled:opacity-60',
        variantStyles[variant],
        sizeStyles[size],
        fullWidth ? 'w-full' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </button>
  );
}
